function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import ServiceFactory from "../../service";
import { INPUT } from "../../components/form-styles";
import { num, usd } from "../sales/territory-common";

// Content Hub templates (CONTENT_HUB_TEMPLATES_2026-10-01): a template is a recipe for a piece (channel, copy shape, media
// recipe, reference). Shared by the Builder (picker, Add a reference, Save as template), the piece page and Settings.
// House rules: kit tokens only, no credit copy, no vertical hard-coded anywhere.

function svc(api) {
  const S = ServiceFactory.getType(api, "product");
  return new S();
}
async function safe(p, fb) {
  try {
    return (await p) || fb;
  } catch (e) {
    return fb;
  }
}
function toast(msg) {
  const t = document.querySelector("paper-toast");
  if (t && msg) t.show(msg);
}
export const CHANNEL_LABEL = {
  ad: "Ad",
  product_copy: "Product copy",
  blog: "Blog",
  landing: "Landing page",
  email: "Email",
  social_instagram: "Instagram",
  social_facebook: "Facebook",
  social_pinterest: "Pinterest",
  social_linkedin: "LinkedIn",
  gbp_post: "Google Business",
  video: "Video",
  any: "Any channel"
};
export const CHANNEL_ICON = {
  ad: "campaign",
  product_copy: "inventory_2",
  blog: "article",
  landing: "web",
  email: "mail_outline",
  social_instagram: "photo_camera",
  social_facebook: "thumb_up_off_alt",
  social_pinterest: "push_pin",
  social_linkedin: "work_outline",
  gbp_post: "storefront",
  video: "movie",
  any: "all_inclusive"
};
const MEDIA_KINDS = [["none", "No media"], ["image", "Image"], ["image_set", "Image set"], ["reel", "Reel 9:16"], ["narrated_video", "Narrated video"], ["clip", "Cinematic clip"]];
const ASPECTS = ["1:1", "4:5", "9:16", "16:9", "2:3", "4:3", "2:1"];
const SCENES = [["packshot", "Packshot"], ["in_context", "In context"], ["lifestyle", "Lifestyle"], ["on_model", "On model"], ["flat_lay", "Flat lay"], ["studio", "Studio"]];
export const OWNED = new Set(["product_copy", "blog", "landing", "email", "web"]);
const LAYOUT_TYPES = [["hero", "Hero image"], ["heading", "Heading"], ["text", "Text"], ["split", "Image beside text"], ["gallery", "Image gallery"], ["features", "Feature list"], ["quote", "Quote or proof"], ["cta", "Call to action"], ["specs", "Specs table"]];
const TEXT_BLOCKS = new Set(["heading", "text", "split", "features", "quote", "cta", "specs"]);
/** Body text → groups of {heading, body}: a short line without a closing period opens a new group. */
export function groupBody(body) {
  const paras = String(body || "").split(/\n\s*\n|\n(?=#)/).map(x => x.replace(/^#+\s*/, "").trim()).filter(Boolean);
  const groups = [];
  paras.forEach(pz => {
    const short = pz.length <= 80 && !/[.!?]$/.test(pz);
    if (short) groups.push({
      heading: pz,
      body: []
    });else if (groups.length) groups[groups.length - 1].body.push(pz);else groups.push({
      heading: "",
      body: [pz]
    });
  });
  return groups;
}
const LOGOS = [["none", "No logo"], ["bottom_right", "Logo bottom right"], ["bottom_left", "Logo bottom left"], ["top_left", "Logo top left"], ["top_right", "Logo top right"]];
export function parseJson(s) {
  if (!s) return {};
  if (typeof s === "object") return s;
  try {
    return JSON.parse(s) || {};
  } catch (e) {
    return {};
  }
}
export function recipeOf(t) {
  return t ? {
    copy: parseJson(t.copy),
    media: parseJson(t.media),
    reference: parseJson(t.reference)
  } : {
    copy: {},
    media: {},
    reference: {}
  };
}
export function channelLabel(ch) {
  return CHANNEL_LABEL[String(ch || "").toLowerCase()] || String(ch || "").replace(/_/g, " ");
}

/** Short chips that summarize a recipe on a card or a plan row. */
export function recipeChips(t, max = 4) {
  const {
    copy,
    media
  } = recipeOf(t);
  const out = [];
  if (media && media.kind && media.kind !== "none") out.push(`${media.aspect || ""} ${String(media.kind).replace(/_/g, " ")}`.trim());
  if (media && media.scene) out.push(String(media.scene).replace(/_/g, " "));
  if (media && media.captions && media.captions !== "none") out.push("captions");
  if (media && media.logo && media.logo !== "none") out.push("logo");
  if (media && media.badge) out.push(String(media.badge));
  if (copy && Array.isArray(copy.sections) && copy.sections.length) out.push(copy.sections.join(" › "));
  return out.slice(0, max);
}

/** Angle text a plan row inherits from a recipe. */
export function angleFromRecipe(t) {
  const {
    copy,
    reference
  } = recipeOf(t);
  const parts = [];
  if (Array.isArray(copy.sections) && copy.sections.length) parts.push(`Shape: ${copy.sections.join(", ")}.`);
  if (Array.isArray(copy.tone) && copy.tone.length) parts.push(`Tone: ${copy.tone.join(", ")}.`);
  if (copy.length) parts.push(`Length: ${copy.length}.`);
  if (copy.hashtags && copy.hashtags !== "none") parts.push(`Hashtags: ${copy.hashtags}.`);
  if (copy.link && copy.link !== "none") parts.push(`Link: ${copy.link}.`);
  if (reference && reference.notes) parts.push(String(reference.notes));
  return parts.join(" ");
}

/** Media prompt hint a media row inherits from a recipe. */
export function mediaPromptFromRecipe(t) {
  const {
    media,
    reference
  } = recipeOf(t);
  const parts = [];
  if (media.scene) parts.push(`${String(media.scene).replace(/_/g, " ")} scene`);
  if (media.background === "white") parts.push("clean white background");else if (media.background === "brand") parts.push("brand color background");
  if (media.badge) parts.push(`${media.badge} badge`);
  if (media.logo && media.logo !== "none") parts.push(`logo ${String(media.logo).replace(/_/g, " ")}`);
  if (reference && reference.notes) parts.push(String(reference.notes));
  return parts.join(", ");
}

/** The Builder media row kind a recipe's media kind maps to. */
export function mediaRowFor(t) {
  const k = (recipeOf(t).media || {}).kind;
  return k === "reel" ? "video916" : k === "narrated_video" ? "video169" : k === "clip" ? "cinematic" : k === "image_set" ? "lifestyle" : k === "image" ? "hero" : null;
}
export function TemplateCard({
  t,
  on,
  onClick,
  compact,
  onPreview
}) {
  const ch = String(t.channel || "any").toLowerCase();
  const best = t.pieces >= 3 ? Number(t.sales90) > 0 ? "Best for sales" : Number(t.sessions30) > 0 ? "Best for sessions" : null : null;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "hub-tpl" + (on ? " on" : "") + (compact ? " compact" : ""),
    onClick: onClick,
    title: t.name
  }, /*#__PURE__*/React.createElement("span", {
    className: "hub-tpl-scope"
  }, t.scope === "plunk" ? "Starter" : t.scope === "story" ? "This story" : "Yours"), !compact && /*#__PURE__*/React.createElement("span", {
    className: "hub-tpl-ch"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, CHANNEL_ICON[ch] || "description"), channelLabel(ch)), /*#__PURE__*/React.createElement("b", null, t.name), /*#__PURE__*/React.createElement("span", {
    className: "hub-tpl-chips"
  }, recipeChips(t, compact ? 3 : 4).map((c, i) => /*#__PURE__*/React.createElement("span", {
    key: i
  }, c))), best && /*#__PURE__*/React.createElement("span", {
    className: "hub-tpl-best"
  }, best), onPreview && /*#__PURE__*/React.createElement("span", {
    className: "hub-tpl-eye",
    title: "Preview",
    onClick: e => {
      e.stopPropagation();
      onPreview(t);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "visibility")));
}

/** Wireframe of what a recipe produces: the media frame at its aspect with logo, badge and captions where the recipe puts them,
 *  then the copy as section blocks. With a `sample` (from POST templates/preview) the blocks carry real text. */
export function TemplatePreview({
  recipe,
  channel,
  name,
  sample,
  compact
}) {
  const r = recipe || {};
  const copy = r.copy || {};
  const media = r.media || {};
  const ch = String(channel || r.channel || "any").toLowerCase();
  const sections = Array.isArray(copy.sections) && copy.sections.length ? copy.sections : ["hook", "body", "cta"];
  const bySection = {};
  (sample && sample.sections || []).forEach(x => {
    if (x && x.name) bySection[String(x.name).toLowerCase()] = x.text;
  });
  const [aw, ah] = String(media.aspect || "1:1").split(":").map(Number);
  const hasMedia = media.kind && media.kind !== "none";
  const video = /video|reel|clip/.test(String(media.kind || ""));
  const lines = copy.length === "long" ? 3 : copy.length === "short" ? 1 : 2;
  const frameCls = /social|gbp|^ad$/.test(ch) ? "post" : ch === "email" ? "email" : ch === "product_copy" ? "pdp" : ch === "video" ? "video" : "page";
  return /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp " + frameCls + (compact ? " compact" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-top"
  }, frameCls === "post" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "av"
  }), /*#__PURE__*/React.createElement("span", {
    className: "nm"
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", {
    className: "s"
  }))), frameCls === "email" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "sub"
  }, sample && sample.title ? sample.title : bySection.subject || "Subject line"), /*#__PURE__*/React.createElement("span", {
    className: "from"
  }, /*#__PURE__*/React.createElement("i", null))), (frameCls === "page" || frameCls === "pdp") && /*#__PURE__*/React.createElement("span", {
    className: "bar"
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null)), frameCls === "video" && /*#__PURE__*/React.createElement("span", {
    className: "sub"
  }, name || "Video")), hasMedia && !(Array.isArray(copy.layout) && copy.layout.length > 0 && frameCls !== "post") && /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-media",
    style: {
      aspectRatio: `${aw || 1} / ${ah || 1}`
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "scene " + String(media.scene || "in_context")
  }, String(media.scene || "in context").replace(/_/g, " "), media.kind === "image_set" ? " · set" : ""), media.badge && /*#__PURE__*/React.createElement("span", {
    className: "badge"
  }, media.badge), media.logo && media.logo !== "none" && /*#__PURE__*/React.createElement("span", {
    className: "logo " + media.logo
  }, "LOGO"), video && /*#__PURE__*/React.createElement("span", {
    className: "play"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "play_arrow")), media.captions === "brand" && /*#__PURE__*/React.createElement("span", {
    className: "caps"
  }, "captions"), media.background === "white" && /*#__PURE__*/React.createElement("span", {
    className: "bg"
  }, "white")), Array.isArray(copy.layout) && copy.layout.length > 0 && frameCls !== "post" ? /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-copy"
  }, copy.layout.map((blk, i) => {
    const txt = blk.section ? bySection[String(blk.section).toLowerCase()] : null;
    const sk = /*#__PURE__*/React.createElement("span", {
      className: "sk"
    }, Array.from({
      length: lines
    }).map((_, k) => /*#__PURE__*/React.createElement("i", {
      key: k,
      style: {
        width: `${[92, 78, 64][k % 3]}%`
      }
    })));
    const body = txt ? /*#__PURE__*/React.createElement("p", null, txt) : sk;
    const label = blk.section ? /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, blk.section) : null;
    if (blk.type === "hero") return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb hero",
      style: {
        aspectRatio: "16 / 7"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "scene"
    }, "hero image"), txt && /*#__PURE__*/React.createElement("span", {
      className: "over"
    }, txt));
    if (blk.type === "heading") return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb heading"
    }, label, txt ? /*#__PURE__*/React.createElement("h4", null, txt) : /*#__PURE__*/React.createElement("span", {
      className: "sk"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        width: "70%",
        height: 12
      }
    })));
    if (blk.type === "split") return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb split " + (blk.image === "left" ? "left" : "right")
    }, /*#__PURE__*/React.createElement("span", {
      className: "img"
    }, /*#__PURE__*/React.createElement("span", {
      className: "scene"
    }, "image")), /*#__PURE__*/React.createElement("span", {
      className: "t"
    }, label, body));
    if (blk.type === "gallery") return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb gallery"
    }, [0, 1, 2].map(k => /*#__PURE__*/React.createElement("span", {
      key: k,
      className: "img"
    })));
    if (blk.type === "features") return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb features"
    }, label, [0, 1, 2].map(k => /*#__PURE__*/React.createElement("span", {
      key: k,
      className: "row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "check_circle"), txt && k === 0 ? /*#__PURE__*/React.createElement("p", null, txt) : /*#__PURE__*/React.createElement("i", {
      style: {
        width: `${[80, 65, 72][k]}%`
      }
    }))));
    if (blk.type === "quote") return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb quote"
    }, label, body);
    if (blk.type === "cta") return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb cta"
    }, label, /*#__PURE__*/React.createElement("span", {
      className: "hub-tplp-btn"
    }, txt || "Call to action"));
    if (blk.type === "specs") return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb specs"
    }, label, [0, 1, 2].map(k => /*#__PURE__*/React.createElement("span", {
      key: k,
      className: "row"
    }, /*#__PURE__*/React.createElement("i", {
      style: {
        width: "30%"
      }
    }), /*#__PURE__*/React.createElement("i", {
      style: {
        width: "45%"
      }
    }))));
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "lb text"
    }, label, body);
  }), frameCls === "email" && !copy.layout.some(b => b.type === "cta") && /*#__PURE__*/React.createElement("span", {
    className: "hub-tplp-btn"
  }, "Shop now")) : /*#__PURE__*/React.createElement(React.Fragment, null, (frameCls === "page" || frameCls === "pdp") && /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-h1"
  }, sample && sample.title ? sample.title : bySection.headline || bySection.title || "Headline"), /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-copy"
  }, sections.map((sec, i) => {
    const txt = bySection[String(sec).toLowerCase()];
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "hub-tplp-sec"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, sec), txt ? /*#__PURE__*/React.createElement("p", null, txt) : /*#__PURE__*/React.createElement("span", {
      className: "sk"
    }, Array.from({
      length: Math.max(1, Math.min(4, lines + (i === 0 ? 0 : 0)))
    }).map((_, k) => /*#__PURE__*/React.createElement("i", {
      key: k,
      style: {
        width: `${[92, 78, 64, 50][k % 4]}%`
      }
    }))));
  }), copy.hashtags && copy.hashtags !== "none" && /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-tags"
  }, "#", String(copy.hashtags).split(/[ ,]/)[0] || "tag", " #brand #category"), frameCls === "email" && /*#__PURE__*/React.createElement("span", {
    className: "hub-tplp-btn"
  }, bySection["one button"] || bySection.cta || "Shop now"), sample && sample.media && /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-note"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "image"), sample.media))));
}

/** A finished piece as it lands on its channel (Ship preview, 2026-10-02): real title and body, the media that ships, the link. */
// editable (Make, 2026-10-02): the caption edits in place (onEditBody gets the new text on blur; Escape cancels) and the media
// is a click target (onMediaClick) so a social post works like a page on the canvas.
export function PiecePreview({
  channel,
  target,
  title,
  body,
  imageUrl,
  videoUrl,
  posterUrl,
  link,
  compact,
  layout,
  images,
  editable,
  onEditBody,
  onMediaClick
}) {
  const ch = String(channel || "").toLowerCase();
  const tg = String(target || "").toLowerCase();
  // A rendered piece (the Make stage writes HTML for owned channels): show it as it is.
  if (OWNED.has(ch) && /<(section|table|div|h1|h2|p|article)[\s>]/i.test(String(body || ""))) {
    const doc = /<html/i.test(body) ? body : `<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style>body{margin:0;background:#fff;color:#26261f;font-family:-apple-system,'Segoe UI',Arial,sans-serif;line-height:1.55}.plk-page{max-width:960px;margin:0 auto;padding:0 20px 40px}.plk-page img{max-width:100%;height:auto;display:block}.plk-grid{display:grid;gap:20px}@media(min-width:720px){.plk-2{grid-template-columns:1fr 1fr}.plk-3{grid-template-columns:repeat(3,1fr)}}.plk-page h1{font-size:34px;line-height:1.15;margin:0 0 10px}.plk-page h2{font-size:24px;line-height:1.25;margin:0 0 8px}.plk-page p{margin:0 0 12px;font-size:16px}.plk-btn{display:inline-block;padding:12px 24px;border-radius:8px;color:#fff;text-decoration:none;font-weight:600}</style></head><body><article class="plk-page">${body}</article></body></html>`;
    return /*#__PURE__*/React.createElement("div", {
      className: "hub-tplp real html " + (ch === "email" ? "email" : "page") + (compact ? " compact" : "")
    }, /*#__PURE__*/React.createElement("iframe", {
      title: "Piece",
      sandbox: "",
      srcDoc: doc
    }));
  }
  const frameCls = /social|facebook|instagram|pinterest|linkedin|gbp|^ad$/.test(ch + " " + tg) ? "post" : ch === "email" ? "email" : ch === "product_copy" ? "pdp" : ch === "video" ? "video" : "page";
  const paras = String(body || "").split(/\n\s*\n/).map(x => x.trim()).filter(Boolean);
  const host = u => {
    try {
      return new URL(u).hostname.replace(/^www\./, "");
    } catch (e) {
      return u;
    }
  };
  const pics = (images || []).filter(Boolean);
  if (imageUrl && !pics.includes(imageUrl)) pics.unshift(imageUrl);
  if (Array.isArray(layout) && layout.length && frameCls !== "post" && frameCls !== "video") {
    // Owned channel with a layout: pour the body's heading groups into the text-bearing blocks, pictures into the image blocks.
    const groups = groupBody(body);
    let g = 0,
      pi = 0;
    const nextGroup = () => groups[g++] || null;
    const nextPic = () => pics[pi++ % Math.max(1, pics.length)] || null;
    const blocks = layout.map((blk, i) => {
      if (blk.type === "hero") {
        const u = nextPic();
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: "lb hero real"
        }, u ? /*#__PURE__*/React.createElement("img", {
          src: u,
          alt: ""
        }) : /*#__PURE__*/React.createElement("span", {
          className: "scene"
        }, "hero image"), i === 0 && title && /*#__PURE__*/React.createElement("span", {
          className: "over"
        }, title));
      }
      if (blk.type === "gallery") return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "lb gallery"
      }, [0, 1, 2].map(k => {
        const u = nextPic();
        return /*#__PURE__*/React.createElement("span", {
          key: k,
          className: "img"
        }, u && /*#__PURE__*/React.createElement("img", {
          src: u,
          alt: ""
        }));
      }));
      const grp = TEXT_BLOCKS.has(blk.type) ? nextGroup() : null;
      const head = grp && grp.heading ? /*#__PURE__*/React.createElement("h4", null, grp.heading) : null;
      const ps = grp ? grp.body.map((t, k) => /*#__PURE__*/React.createElement("p", {
        key: k,
        className: "hub-tplp-p"
      }, t)) : null;
      if (blk.type === "heading") return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "lb heading"
      }, head || /*#__PURE__*/React.createElement("h4", null, title), ps);
      if (blk.type === "split") {
        const u = nextPic();
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: "lb split " + (blk.image === "left" ? "left" : "right")
        }, /*#__PURE__*/React.createElement("span", {
          className: "img"
        }, u ? /*#__PURE__*/React.createElement("img", {
          src: u,
          alt: ""
        }) : /*#__PURE__*/React.createElement("span", {
          className: "scene"
        }, "image")), /*#__PURE__*/React.createElement("span", {
          className: "t"
        }, head, ps));
      }
      if (blk.type === "features") return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "lb features"
      }, head, (grp ? grp.body : []).flatMap(t => t.split(/\n|•|^- /m)).map(t => t.trim()).filter(Boolean).slice(0, 6).map((t, k) => /*#__PURE__*/React.createElement("span", {
        key: k,
        className: "row"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "check_circle"), /*#__PURE__*/React.createElement("p", null, t))));
      if (blk.type === "quote") return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "lb quote"
      }, head, ps);
      if (blk.type === "cta") return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "lb cta"
      }, head, ps, /*#__PURE__*/React.createElement("span", {
        className: "hub-tplp-btn"
      }, grp && grp.heading || "Shop now"));
      if (blk.type === "specs") return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "lb specs"
      }, head, (grp ? grp.body : []).flatMap(t => t.split(/\n/)).filter(Boolean).slice(0, 8).map((t, k) => {
        const m = t.split(/:\s|\s[-–]\s/);
        return /*#__PURE__*/React.createElement("span", {
          key: k,
          className: "row"
        }, /*#__PURE__*/React.createElement("b", null, m[0]), /*#__PURE__*/React.createElement("span", null, m.slice(1).join(" ")));
      }));
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "lb text"
      }, head, ps);
    });
    const rest = groups.slice(g).map((grp, k) => /*#__PURE__*/React.createElement("div", {
      key: "r" + k,
      className: "lb text"
    }, grp.heading && /*#__PURE__*/React.createElement("h4", null, grp.heading), grp.body.map((t, j) => /*#__PURE__*/React.createElement("p", {
      key: j,
      className: "hub-tplp-p"
    }, t))));
    return /*#__PURE__*/React.createElement("div", {
      className: "hub-tplp real " + frameCls + (compact ? " compact" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-tplp-top"
    }, frameCls === "email" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "sub"
    }, title || "(no subject)"), /*#__PURE__*/React.createElement("span", {
      className: "from"
    }, /*#__PURE__*/React.createElement("i", null))) : /*#__PURE__*/React.createElement("span", {
      className: "bar"
    }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null))), /*#__PURE__*/React.createElement("div", {
      className: "hub-tplp-copy"
    }, blocks, rest, link && /*#__PURE__*/React.createElement("a", {
      className: "hub-tplp-link",
      href: link,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "link"), host(link))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp real " + frameCls + (compact ? " compact" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-top"
  }, frameCls === "post" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "av"
  }), /*#__PURE__*/React.createElement("span", {
    className: "nm"
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", {
    className: "s"
  })), /*#__PURE__*/React.createElement("span", {
    className: "where"
  }, channelLabel(ch), tg && tg !== ch ? ` · ${tg.replace(/_/g, " ")}` : "")), frameCls === "email" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "sub"
  }, title || "(no subject)"), /*#__PURE__*/React.createElement("span", {
    className: "from"
  }, /*#__PURE__*/React.createElement("i", null))), (frameCls === "page" || frameCls === "pdp") && /*#__PURE__*/React.createElement("span", {
    className: "bar"
  }, /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null), /*#__PURE__*/React.createElement("i", null)), frameCls === "video" && /*#__PURE__*/React.createElement("span", {
    className: "sub"
  }, title || "Video")), imageUrl || videoUrl ? /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-media real" + (editable ? " editable" : ""),
    onClick: editable && onMediaClick ? onMediaClick : undefined,
    title: editable ? "Click to pick a different image or video" : undefined
  }, videoUrl ? /*#__PURE__*/React.createElement("video", {
    src: videoUrl,
    poster: posterUrl || undefined,
    controls: !editable,
    playsInline: true,
    preload: "metadata"
  }) : /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    alt: ""
  }), editable && /*#__PURE__*/React.createElement("span", {
    className: "hub-tplp-media-hint"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "photo_library"), "Pick")) : editable && frameCls === "post" ? /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-media real editable empty",
    onClick: onMediaClick,
    title: "Pick an image or video"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hub-tplp-media-hint"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "add_photo_alternate"), "Add media")) : null, (frameCls === "page" || frameCls === "pdp") && title && /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-h1"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "hub-tplp-copy"
  }, frameCls === "post" && title && !/^(ad|social)/.test(ch) && /*#__PURE__*/React.createElement("p", {
    className: "hub-tplp-t"
  }, title), editable ? /*#__PURE__*/React.createElement(EditableCaption, {
    text: String(body || ""),
    onCommit: onEditBody
  }) : paras.length ? paras.map((t, i) => /*#__PURE__*/React.createElement("p", {
    key: i,
    className: "hub-tplp-p"
  }, t)) : /*#__PURE__*/React.createElement("p", {
    className: "hub-tplp-p territory-hint",
    style: {
      margin: 0
    }
  }, "No copy on this variant."), link && /*#__PURE__*/React.createElement("a", {
    className: "hub-tplp-link",
    href: link,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "link"), host(link)), frameCls === "email" && /*#__PURE__*/React.createElement("span", {
    className: "hub-tplp-btn"
  }, "Shop now")));
}

/** The caption of a post, edited in place: click to edit, blur or Cmd/Ctrl+Enter saves, Escape puts it back. */
class EditableCaption extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "ref", /*#__PURE__*/React.createRef());
    _defineProperty(this, "orig", "");
    _defineProperty(this, "start", () => {
      const el = this.ref.current;
      if (!el || el.isContentEditable) return;
      this.orig = el.innerText;
      el.setAttribute("contenteditable", "true");
      el.focus();
    });
    _defineProperty(this, "finish", cancel => {
      const el = this.ref.current;
      if (!el || !el.isContentEditable) return;
      el.removeAttribute("contenteditable");
      const value = el.innerText.replace(/\u00a0/g, " ").trimEnd();
      if (cancel) {
        el.innerText = this.orig;
        return;
      }
      if (value !== this.orig && this.props.onCommit) this.props.onCommit(value);
    });
  }
  render() {
    const {
      text
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.ref,
      className: "hub-tplp-caption" + (text ? "" : " empty"),
      "data-placeholder": "Click to write the caption",
      onClick: this.start,
      onBlur: () => this.finish(false),
      onKeyDown: e => {
        if (e.key === "Escape") {
          e.preventDefault();
          this.finish(true);
          this.ref.current.blur();
        } else if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
          e.preventDefault();
          this.ref.current.blur();
        }
      },
      suppressContentEditableWarning: true
    }, text);
  }
}

/** Preview sheet: the wireframe, plus "Write a sample" that grounds it on a piece when containerId is given. */
export class TemplatePreviewSheet extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      sample: null,
      busy: false
    });
    _defineProperty(this, "sample", async () => {
      const {
        t,
        recipe,
        containerId
      } = this.props;
      this.setState({
        busy: true
      });
      try {
        const body = JSON.stringify({
          recipe: t ? undefined : {
            name: recipe.name,
            channel: recipe.channel,
            copy: recipe.copy,
            media: recipe.media
          },
          notes: recipe && recipe.notes
        }).replace(/}$/, `${t ? `,"templateId":${String(t.id)}` : ""}${containerId ? `,"containerId":${String(containerId)}` : ""}}`);
        const r = await svc("/content/templates/preview").postAsync(body);
        if (r && r.sections) this.setState({
          sample: r
        });else toast("The sample could not be written.");
      } catch (e) {
        toast(e && e.message || "The sample could not be written.");
      } finally {
        this.setState({
          busy: false
        });
      }
    });
  }
  render() {
    const {
      t,
      recipe,
      containerId,
      onClose,
      onPick
    } = this.props;
    const rec = t ? {
      copy: parseJson(t.copy),
      media: parseJson(t.media),
      channel: t.channel,
      name: t.name
    } : recipe;
    const {
      sample,
      busy
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-sheet hub-tplp-sheet",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-tplp-head"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, rec.name || t && t.name || "Template"), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, channelLabel(rec.channel), " \xB7 ", sample ? "sample written from " + (containerId ? "this story" : "a neutral product") : "the shape, with placeholder lines")), /*#__PURE__*/React.createElement("span", {
      className: "hub-tplp-acts"
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      style: {
        margin: 0
      },
      disabled: busy,
      onClick: this.sample
    }, busy ? "Writing…" : sample ? "Write another sample" : containerId ? "Write a sample from this story" : "Write a sample"), onPick && t && /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-primary",
      onClick: () => {
        onPick(t);
        onClose();
      }
    }, "Use this template"), /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle sm",
      style: {
        margin: 0
      },
      onClick: onClose
    }, "Close"))), /*#__PURE__*/React.createElement("div", {
      className: "hub-tplp-stage"
    }, /*#__PURE__*/React.createElement(TemplatePreview, {
      recipe: rec,
      channel: rec.channel,
      name: rec.name,
      sample: sample
    })), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "10px 0 0"
      }
    }, "A preview shows the shape and placement. The real piece is written from your story's copy and your brand kit when you run the Builder.")));
  }
}

/**
 * Add a reference / Save as template / Edit template. One sheet, three entries:
 *  - reference: tabs (Paste copy, Image, Page URL, Past piece) → POST templates/extract → review → save
 *  - variant: extract straight from a variant id → review → save
 *  - edit: an existing template → review → save (PUT)
 */
export class TemplateSheet extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "extract", async () => {
      const {
        tab,
        text,
        imageUrl,
        url,
        variantId
      } = this.state;
      const body = tab === "variant" ? {
        variantId: String(variantId)
      } : tab === "image" ? {
        imageUrl
      } : tab === "url" ? {
        url
      } : {
        text
      };
      if (!Object.values(body)[0]) return;
      this.setState({
        busy: true
      });
      try {
        // variant ids exceed 2^53: send as a raw number literal
        const raw = tab === "variant" ? `{"variantId":${String(variantId)}${this.props.channel ? `,"channel":"${this.props.channel}"` : ""}}` : JSON.stringify({
          ...body,
          channel: this.props.channel || undefined
        });
        const r = await svc("/content/templates/extract").postAsync(raw);
        if (!r || !r.copy) {
          toast("The reference could not be read into a recipe.");
          return;
        }
        this.setState({
          recipe: {
            name: r.name || "",
            channel: r.channel || this.props.channel || "any",
            copy: r.copy || {},
            media: r.media || {},
            reference: r.reference || {},
            notes: r.notes || r.reference && r.reference.notes || ""
          }
        });
      } catch (e) {
        toast(e && e.message || "Could not read the reference.");
      } finally {
        this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "save", async () => {
      const {
        recipe,
        storyFirst
      } = this.state;
      if (!recipe || !recipe.name.trim()) {
        toast("Give the template a name.");
        return;
      }
      this.setState({
        busy: true
      });
      try {
        const payload = {
          name: recipe.name.trim(),
          channel: recipe.channel || "any",
          copy: recipe.copy,
          media: recipe.media,
          reference: {
            ...(recipe.reference || {}),
            notes: recipe.notes || ""
          },
          scope: storyFirst && this.props.storyId ? "story" : "workspace",
          storyId: storyFirst && this.props.storyId ? undefined : undefined,
          sourceVariantId: undefined
        };
        // story and variant ids exceed 2^53: splice them in as raw literals
        let raw = JSON.stringify(payload);
        if (storyFirst && this.props.storyId) raw = raw.replace(/}$/, `,"storyId":${String(this.props.storyId)}}`);
        const sv = this.state.variantId || recipe.reference && recipe.reference.variantId;
        if (sv) raw = raw.replace(/}$/, `,"sourceVariantId":${String(sv)}}`);
        const saved = this.props.template && this.props.template.id ? await svc(`/content/templates/${String(this.props.template.id)}`).putAsync(raw) : await svc("/content/templates").postAsync(raw);
        toast(this.props.template ? "Template saved." : `Template "${recipe.name.trim()}" saved.`);
        if (this.props.onSaved) this.props.onSaved(saved);
        this.props.onClose();
      } catch (e) {
        toast(e && e.message || "Could not save the template.");
      } finally {
        this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "setR", patch => this.setState({
      recipe: {
        ...this.state.recipe,
        ...patch
      }
    }));
    _defineProperty(this, "setCopy", patch => this.setR({
      copy: {
        ...(this.state.recipe.copy || {}),
        ...patch
      }
    }));
    _defineProperty(this, "setMedia", patch => this.setR({
      media: {
        ...(this.state.recipe.media || {}),
        ...patch
      }
    }));
    const t = props.template;
    const _r = t ? {
      name: t.name,
      channel: t.channel,
      copy: parseJson(t.copy),
      media: parseJson(t.media),
      reference: parseJson(t.reference),
      notes: (parseJson(t.reference) || {}).notes || ""
    } : null;
    this.state = {
      tab: props.variantId ? "variant" : "text",
      text: "",
      imageUrl: "",
      url: "",
      variantId: props.variantId || "",
      busy: false,
      recipe: _r,
      storyFirst: false
    };
  }
  componentDidMount() {
    if (this.props.variantId && !this.props.template) this.extract();
  }
  render() {
    const {
      tab,
      busy,
      recipe,
      storyFirst
    } = this.state;
    const editing = !!this.props.template;
    const title = editing ? "Edit template" : this.props.variantId ? "Save as template" : "Add a reference";
    const inp = {
      ...INPUT,
      height: "34px",
      padding: "0 10px",
      marginTop: "4px"
    };
    const list = v => Array.isArray(v) ? v.join(", ") : v || "";
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: () => {
        if (!busy) this.props.onClose();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-sheet hub-sched hub-tpl-sheet",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("h3", {
      className: "hub-h3",
      style: {
        marginBottom: 2
      }
    }, title), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 12px"
      }
    }, editing ? "The shape this template asks for. The words always come from the story." : this.props.variantId ? "Captures the shape of this piece, not its words. The next story that uses it gets the same structure with its own copy." : "Paste an example, point at an image or a page, or pick a past piece. The agent reads the shape; you review it before it becomes a template."), !editing && !this.props.variantId && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "seg",
      style: {
        marginBottom: 8
      }
    }, [["text", "Paste copy"], ["image", "Image"], ["url", "Page URL"], ["variant", "Past piece"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: tab === k ? "on" : "",
      onClick: () => this.setState({
        tab: k
      })
    }, l))), tab === "text" && /*#__PURE__*/React.createElement("textarea", {
      rows: 5,
      value: this.state.text,
      placeholder: "Paste the post, email or page copy you want to learn the shape from",
      onChange: e => this.setState({
        text: e.target.value
      }),
      style: {
        ...INPUT,
        resize: "vertical"
      }
    }), tab === "image" && /*#__PURE__*/React.createElement("input", {
      value: this.state.imageUrl,
      placeholder: "https://\u2026 an image of the post or ad",
      onChange: e => this.setState({
        imageUrl: e.target.value
      }),
      style: inp
    }), tab === "url" && /*#__PURE__*/React.createElement("input", {
      value: this.state.url,
      placeholder: "https://\u2026 the page to learn from",
      onChange: e => this.setState({
        url: e.target.value
      }),
      style: inp
    }), tab === "variant" && /*#__PURE__*/React.createElement("select", {
      value: this.state.variantId,
      onChange: e => this.setState({
        variantId: e.target.value
      }),
      style: inp
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Pick a past piece"), (this.props.variants || []).map(v => /*#__PURE__*/React.createElement("option", {
      key: String(v.id),
      value: String(v.id)
    }, channelLabel(v.channel), v.title ? `: ${v.title}` : ""))), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 8
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-sm k-rounded-md k-button-solid k-button-solid-base",
      disabled: busy,
      onClick: this.extract
    }, busy ? "Reading…" : recipe ? "Read it again" : "Read the shape"))), busy && !recipe && /*#__PURE__*/React.createElement("div", {
      className: "hub-bld-empty",
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons"
    }, "hourglass_top"), "Reading the reference\u2026"), recipe && /*#__PURE__*/React.createElement("div", {
      className: "hub-tpl-edit"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-tpl-recipe"
    }, /*#__PURE__*/React.createElement("label", null, "Name", /*#__PURE__*/React.createElement("input", {
      value: recipe.name,
      placeholder: "e.g. Sale reel",
      onChange: e => this.setR({
        name: e.target.value
      }),
      style: inp
    })), /*#__PURE__*/React.createElement("label", null, "Channel", /*#__PURE__*/React.createElement("select", {
      value: recipe.channel || "any",
      onChange: e => this.setR({
        channel: e.target.value
      }),
      style: inp
    }, Object.keys(CHANNEL_LABEL).map(k => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, CHANNEL_LABEL[k])))), /*#__PURE__*/React.createElement("div", {
      className: "hub-tpl-group"
    }, "Copy shape"), /*#__PURE__*/React.createElement("label", null, "Sections ", /*#__PURE__*/React.createElement("i", null, "in order, comma separated"), /*#__PURE__*/React.createElement("input", {
      value: list(recipe.copy.sections),
      placeholder: "hook, offer, proof, cta",
      onChange: e => this.setCopy({
        sections: e.target.value.split(",").map(x => x.trim()).filter(Boolean)
      }),
      style: inp
    })), /*#__PURE__*/React.createElement("div", {
      className: "hub-tpl-two"
    }, /*#__PURE__*/React.createElement("label", null, "Tone", /*#__PURE__*/React.createElement("input", {
      value: list(recipe.copy.tone),
      placeholder: "direct, warm",
      onChange: e => this.setCopy({
        tone: e.target.value.split(",").map(x => x.trim()).filter(Boolean)
      }),
      style: inp
    })), /*#__PURE__*/React.createElement("label", null, "Length", /*#__PURE__*/React.createElement("input", {
      value: recipe.copy.length || "",
      placeholder: "short, medium, long or a word count",
      onChange: e => this.setCopy({
        length: e.target.value
      }),
      style: inp
    })), /*#__PURE__*/React.createElement("label", null, "Hashtags", /*#__PURE__*/React.createElement("input", {
      value: recipe.copy.hashtags || "",
      placeholder: "3 to 5, brand plus category, or none",
      onChange: e => this.setCopy({
        hashtags: e.target.value
      }),
      style: inp
    })), /*#__PURE__*/React.createElement("label", null, "Link", /*#__PURE__*/React.createElement("input", {
      value: recipe.copy.link || "",
      placeholder: "in bio, button, inline, none",
      onChange: e => this.setCopy({
        link: e.target.value
      }),
      style: inp
    }))), OWNED.has(String(recipe.channel || "").toLowerCase()) && (() => {
      const layout = Array.isArray(recipe.copy.layout) ? recipe.copy.layout : [];
      const setLayout = next => {
        const sections = [];
        next.forEach(b => {
          if (b.section && !sections.includes(b.section)) sections.push(b.section);
        });
        this.setCopy({
          layout: next,
          sections: sections.length ? sections : recipe.copy.sections
        });
      };
      const upd = (i, patch) => setLayout(layout.map((b, k) => k === i ? {
        ...b,
        ...patch
      } : b));
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "hub-tpl-group"
      }, "Layout ", /*#__PURE__*/React.createElement("span", {
        className: "territory-hint",
        style: {
          margin: "0 0 0 8px",
          fontWeight: 400
        }
      }, "the page blocks in order; each text block holds one section")), /*#__PURE__*/React.createElement("div", {
        className: "hub-tpl-layout"
      }, layout.map((b, i) => /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "hub-tpl-blk"
      }, /*#__PURE__*/React.createElement("span", {
        className: "n"
      }, i + 1), /*#__PURE__*/React.createElement("select", {
        value: b.type || "text",
        onChange: e => upd(i, {
          type: e.target.value
        })
      }, LAYOUT_TYPES.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
        key: k,
        value: k
      }, l))), TEXT_BLOCKS.has(b.type) ? /*#__PURE__*/React.createElement("input", {
        value: b.section || "",
        placeholder: "section name, e.g. offer",
        onChange: e => upd(i, {
          section: e.target.value
        })
      }) : /*#__PURE__*/React.createElement("span", {
        className: "territory-hint",
        style: {
          margin: 0
        }
      }, "media only"), b.type === "split" && /*#__PURE__*/React.createElement("select", {
        value: b.image || "right",
        onChange: e => upd(i, {
          image: e.target.value
        })
      }, /*#__PURE__*/React.createElement("option", {
        value: "left"
      }, "image left"), /*#__PURE__*/React.createElement("option", {
        value: "right"
      }, "image right")), /*#__PURE__*/React.createElement("span", {
        className: "acts"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        title: "Move up",
        disabled: i === 0,
        onClick: () => {
          const n = layout.slice();
          [n[i - 1], n[i]] = [n[i], n[i - 1]];
          setLayout(n);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "arrow_upward")), /*#__PURE__*/React.createElement("button", {
        type: "button",
        title: "Move down",
        disabled: i === layout.length - 1,
        onClick: () => {
          const n = layout.slice();
          [n[i + 1], n[i]] = [n[i], n[i + 1]];
          setLayout(n);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "arrow_downward")), /*#__PURE__*/React.createElement("button", {
        type: "button",
        title: "Remove",
        onClick: () => setLayout(layout.filter((_, k) => k !== i))
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "close"))))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "hub-tpl-addlink",
        onClick: () => setLayout([...layout, {
          type: "text",
          section: ""
        }])
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, "add"), "Add a block")));
    })(), /*#__PURE__*/React.createElement("div", {
      className: "hub-tpl-group"
    }, "Media recipe"), /*#__PURE__*/React.createElement("div", {
      className: "hub-tpl-two"
    }, /*#__PURE__*/React.createElement("label", null, "Kind", /*#__PURE__*/React.createElement("select", {
      value: recipe.media.kind || "none",
      onChange: e => this.setMedia({
        kind: e.target.value
      }),
      style: inp
    }, MEDIA_KINDS.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement("label", null, "Aspect", /*#__PURE__*/React.createElement("select", {
      value: recipe.media.aspect || "1:1",
      onChange: e => this.setMedia({
        aspect: e.target.value
      }),
      style: inp
    }, ASPECTS.map(a => /*#__PURE__*/React.createElement("option", {
      key: a,
      value: a
    }, a)))), /*#__PURE__*/React.createElement("label", null, "Scene", /*#__PURE__*/React.createElement("select", {
      value: recipe.media.scene || "in_context",
      onChange: e => this.setMedia({
        scene: e.target.value
      }),
      style: inp
    }, SCENES.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement("label", null, "Logo", /*#__PURE__*/React.createElement("select", {
      value: recipe.media.logo || "none",
      onChange: e => this.setMedia({
        logo: e.target.value
      }),
      style: inp
    }, LOGOS.map(([k, l]) => /*#__PURE__*/React.createElement("option", {
      key: k,
      value: k
    }, l)))), /*#__PURE__*/React.createElement("label", null, "Badge", /*#__PURE__*/React.createElement("input", {
      value: recipe.media.badge || "",
      placeholder: "SALE, NEW, or empty",
      onChange: e => this.setMedia({
        badge: e.target.value || null
      }),
      style: inp
    })), /*#__PURE__*/React.createElement("label", null, "Captions", /*#__PURE__*/React.createElement("select", {
      value: recipe.media.captions || "none",
      onChange: e => this.setMedia({
        captions: e.target.value
      }),
      style: inp
    }, /*#__PURE__*/React.createElement("option", {
      value: "none"
    }, "None"), /*#__PURE__*/React.createElement("option", {
      value: "brand"
    }, "Brand preset")))), /*#__PURE__*/React.createElement("label", null, "Notes ", /*#__PURE__*/React.createElement("i", null, "what makes this shape work"), /*#__PURE__*/React.createElement("textarea", {
      rows: 2,
      value: recipe.notes || "",
      onChange: e => this.setR({
        notes: e.target.value
      }),
      style: {
        ...INPUT,
        marginTop: 4,
        resize: "vertical"
      }
    })), this.props.storyId && !editing && /*#__PURE__*/React.createElement("label", {
      className: "hub-tpl-check"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: storyFirst,
      onChange: e => this.setState({
        storyFirst: e.target.checked
      })
    }), " Offer it first on this story")), /*#__PURE__*/React.createElement("div", {
      className: "hub-tpl-live"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-bld-eyebrow",
      style: {
        marginBottom: 6
      }
    }, "Preview"), /*#__PURE__*/React.createElement(TemplatePreview, {
      recipe: recipe,
      channel: recipe.channel,
      name: recipe.name,
      compact: true
    }))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        gap: 8,
        marginTop: 16
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0
      },
      disabled: busy,
      onClick: this.props.onClose
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: busy || !recipe || !(recipe.name || "").trim(),
      onClick: this.save
    }, busy ? "Saving…" : editing ? "Save" : "Save template"))));
  }
}

/** Settings, Content, Templates: starters first, then yours; pieces made, sessions and sales; Duplicate, Edit, Archive. */
export class TemplatesList extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      items: undefined,
      edit: null,
      busy: {},
      preview: null
    });
    _defineProperty(this, "load", async () => {
      const r = await safe(svc("/content/templates").getAsync(), {
        items: []
      });
      if (this._alive) this.setState({
        items: r && r.items || []
      });
    });
    _defineProperty(this, "act", async (t, what) => {
      this.setState({
        busy: {
          ...this.state.busy,
          [String(t.id)]: what
        }
      });
      try {
        if (what === "duplicate") {
          await svc(`/content/templates/${String(t.id)}/duplicate`).postAsync({});
          toast("Copied. Edit the copy to make it yours.");
        }
        if (what === "archive") {
          await svc(`/content/templates/${String(t.id)}`).deleteAsync();
          toast("Archived.");
        }
        await this.load();
      } catch (e) {
        toast(e && e.message || "That did not go through.");
      } finally {
        if (this._alive) this.setState({
          busy: {
            ...this.state.busy,
            [String(t.id)]: null
          }
        });
      }
    });
  }
  componentDidMount() {
    this._alive = true;
    this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  render() {
    const {
      items,
      edit,
      busy
    } = this.state;
    if (items === undefined) return /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "Loading templates\u2026");
    const groups = [["plunk", "Starters"], ["workspace", "Yours"], ["story", "Story templates"]];
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "hub-assets-bar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, items.length, " template", items.length === 1 ? "" : "s", " \xB7 starters are read-only, duplicate one to edit it"), /*#__PURE__*/React.createElement("span", {
      className: "hub-assets-actions"
    }, /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      onClick: () => this.setState({
        edit: {
          fresh: true
        }
      })
    }, "Add a reference"))), groups.map(([scope, label]) => {
      const rows = items.filter(t => t.scope === scope);
      if (!rows.length) return null;
      return /*#__PURE__*/React.createElement("div", {
        key: scope,
        className: "hub-tpl-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "hub-lib-section"
      }, label, /*#__PURE__*/React.createElement("i", null, rows.length)), /*#__PURE__*/React.createElement("table", {
        className: "territory-table wa-table"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Template"), /*#__PURE__*/React.createElement("th", null, "Channel"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Pieces"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Sessions 30d"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Sales 90d"), /*#__PURE__*/React.createElement("th", null, "Last used"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, rows.map(t => {
        const b = busy[String(t.id)];
        const best = t.pieces >= 3 ? Number(t.sales90) > 0 ? "Best for sales" : Number(t.sessions30) > 0 ? "Best for sessions" : null : null;
        return /*#__PURE__*/React.createElement("tr", {
          key: String(t.id)
        }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, t.name), best && /*#__PURE__*/React.createElement("span", {
          className: "hub-tpl-best",
          style: {
            marginLeft: 8
          }
        }, best), /*#__PURE__*/React.createElement("div", {
          className: "territory-hint",
          style: {
            margin: 0
          }
        }, recipeChips(t, 5).join(" · "))), /*#__PURE__*/React.createElement("td", null, channelLabel(t.channel)), /*#__PURE__*/React.createElement("td", {
          className: "n"
        }, num(t.pieces || 0)), /*#__PURE__*/React.createElement("td", {
          className: "n"
        }, Number(t.sessions30) > 0 ? num(t.sessions30) : "—"), /*#__PURE__*/React.createElement("td", {
          className: "n"
        }, Number(t.sales90) > 0 ? usd(t.sales90) : "—"), /*#__PURE__*/React.createElement("td", null, t.lastUsed ? String(t.lastUsed).slice(0, 10) : "never"), /*#__PURE__*/React.createElement("td", {
          className: "n",
          style: {
            whiteSpace: "nowrap"
          }
        }, /*#__PURE__*/React.createElement("button", {
          className: "territory-toggle xs",
          onClick: () => this.setState({
            preview: t
          })
        }, "Preview"), " ", scope === "plunk" ? /*#__PURE__*/React.createElement("button", {
          className: "territory-toggle xs",
          disabled: !!b,
          onClick: () => this.act(t, "duplicate")
        }, b === "duplicate" ? "…" : "Duplicate") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
          className: "territory-toggle xs",
          onClick: () => this.setState({
            edit: t
          })
        }, "Edit"), " ", /*#__PURE__*/React.createElement("button", {
          className: "territory-toggle xs",
          disabled: !!b,
          onClick: () => this.act(t, "duplicate")
        }, "Duplicate"), " ", /*#__PURE__*/React.createElement("button", {
          className: "territory-toggle xs hub-del",
          disabled: !!b,
          onClick: () => this.act(t, "archive")
        }, b === "archive" ? "…" : "Archive"))));
      }))));
    }), edit && /*#__PURE__*/React.createElement(TemplateSheet, {
      template: edit.fresh ? null : edit,
      onSaved: () => this.load(),
      onClose: () => this.setState({
        edit: null
      })
    }), this.state.preview && /*#__PURE__*/React.createElement(TemplatePreviewSheet, {
      t: this.state.preview,
      onClose: () => this.setState({
        preview: null
      })
    }));
  }
}

// A video variant's file: the NEWEST video_ref block for exactly that variant (an Edit or Trim adds a newer one, so
// Publish sends the edited file; "variant:12" must not match "variant:123").
export function videoRefFor(blocks, vid) {
  const re = new RegExp(`(^|\\s)variant:${String(vid)}(\\s|$)`);
  const hits = (blocks || []).filter(b => String(b.kind || "") === "video_ref" && re.test(String(b.body || "")));
  return hits.sort((a, b) => {
    const x = String(a.id || ""),
      y = String(b.id || "");
    return x.length - y.length || x.localeCompare(y);
  }).pop() || null;
}